import Link from 'next/link'
import pjson from 'package.json'
import PatreonBanner from '@components/shared/PatreonBanner'
import FooterIconPack from './FooterIconPack'
import VersionBanner from './VersionBanner'

const Footer = () => {
  return (
    <footer className="flex w-full flex-col items-center justify-center border-t py-1 dark:border-slate-600">
      <div className="px-5 w-full">
        <PatreonBanner />
      </div>
      <FooterIconPack />
      <p className="text-xs">
        Hayırhah, bir{' '}
        <a
          className="text-blue-800 dark:text-blue-400"
          href="https://kurantime.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Kuran Time
        </a>{' '}
        projesidir.
      </p>
      <Link href={'/versiyonlar'} className="pt-2 text-xs">
        Hayırhah v{pjson.version}
      </Link>
      <VersionBanner />
    </footer>
  )
}

export default Footer
